import { connect } from 'react-redux'
import { getUserCompanies, hasRoleInCompany, isAuthenticated } from '../../common/auth/authSelectors'
import { IGlobalState } from '../../Root/store/appReducer'
import {
  getCompanyRanking as getCompanyRankingAction,
  toggleCompanyExcludedFromRanking,
} from './store/CompanyRankingActions'
import { CompanyRanking, IDispatchProps, IStateProps } from './CompanyRanking'
import {
  getCompanyRanking,
  getCompanyRankingLoading,
  getPeriodPercentage,
  getCompanyIsExcludedFromRanking,
} from './store/CompanyRankingSelectors'
import { CompanyId, Role } from '../../services/api.types'

const mapStateToProps = (state: IGlobalState): IStateProps => ({
  hasRoleInCompany: (companyId: CompanyId, role: Role) => hasRoleInCompany(state, companyId, role),
  authenticated: isAuthenticated(state),
  userCompanies: getUserCompanies(state),
  periodPercentage: getPeriodPercentage(state),
  companyIsExcludedFromRanking: getCompanyIsExcludedFromRanking(state),
  companyRanking: getCompanyRanking(state),
  companyRankingLoading: getCompanyRankingLoading(state),
})

const mapDispatchToProps: IDispatchProps = {
  getCompanyRankingAction,
  toggleCompanyExcludedFromRanking,
}

export default connect(mapStateToProps, mapDispatchToProps)(CompanyRanking)
